import { VenueShowType } from '@api';
import {
  ActionsCell,
  ArtistAnchor,
  formatDate,
  StatusBadge,
  TourAnchor,
} from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

export type UseColumnsReturnType = {
  columns: DataTableColumn<VenueShowType>[];
};

export const useColumns = (): UseColumnsReturnType => {
  const { t } = useTranslation('venueDetailsShows');

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return {
    columns: [
      {
        accessor: 'date',
        title: t('ROWS.DATE'),
        render: (record) => formatDate(record.date),
      },
      {
        accessor: 'artist',
        title: t('ROWS.ARTIST'),
        render: (record) => <ArtistAnchor artist={record.artist} />,
      },
      {
        accessor: 'tour',
        title: t('ROWS.TOUR'),
        render: (record) =>
          record.tour ? <TourAnchor tour={record.tour} /> : noDataPlaceholder,
      },
      {
        accessor: 'status',
        title: t('ROWS.STATUS'),
        render: (record) => <StatusBadge status={record.status} />,
      },
      {
        accessor: 'production',
        title: t('ROWS.PRODUCTION'),
        render: (record) => record.production ?? noDataPlaceholder,
      },
      {
        accessor: 'showSetup',
        title: t('ROWS.SHOW_SETUP'),
        render: (record) => record.showSetup ?? noDataPlaceholder,
      },
      {
        accessor: 'configuration',
        title: t('ROWS.CONFIGURATIONS'),
        render: (record) =>
          t(`CONFIGURATIONS.${record.configuration}`, { ns: 'venueDetails' }),
      },
      {
        accessor: 'rentalAgreementUrl',
        title: t('ROWS.RENTAL_AGREEMENT_URL'),
        titleStyle: { textAlign: 'center' },
        render: (record) => (
          <ActionsCell.Root>
            {record.rentalAgreementUrl ? (
              <ActionsCell.PdfDownload url={record.rentalAgreementUrl} />
            ) : (
              noDataPlaceholder
            )}
          </ActionsCell.Root>
        ),
      },
    ],
  };
};
